class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.modalContent = this.querySelector('.modal-content'); // element that animates

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    // Open details
    this.detailsContainer.setAttribute('open', true);
    this.classList.add('open'); // add open class
    document.body.classList.add('overflow-hidden');
    document.body.addEventListener('click', this.onBodyClickEvent);

    const input = this.querySelector('input[type="search"], input[name="q"]');
    if (input) {
      setTimeout(() => input.focus(), 100); 
    }

    // Trap focus immediately
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    // Wait for opening animation to finish
    if (this.modalContent) {
      this.modalContent.classList.add('is-visible'); // trigger CSS animation
      const onTransitionEnd = () => {
        this.modalContent.removeEventListener('transitionend', onTransitionEnd);
        // Any logic after animation completes
      };
      this.modalContent.addEventListener('transitionend', onTransitionEnd);
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);

    const finishClose = () => {
      this.detailsContainer.removeAttribute('open');
      this.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
      document.body.removeEventListener('click', this.onBodyClickEvent);
    };

    if (this.modalContent) {
      this.modalContent.classList.remove('is-visible'); // trigger closing animation
      const onTransitionEnd = () => {
        finishClose();
        this.modalContent.removeEventListener('transitionend', onTransitionEnd);
      };
      this.modalContent.addEventListener('transitionend', onTransitionEnd);
    } else {
      finishClose();
    }
  }
}

customElements.define('details-modal', DetailsModal);
